var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4",
    "data-name": "Group 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196,
    height: 31.631,
    viewBox: "0 0 196 31.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 196,
    height: 31.631,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M140.358,35.219l-.071-.024a6.322,6.322,0,0,1-4.753,1.877c-3.088,0-5.061-1.5-5.061-4.681,0-2.567,2-4.4,5.893-4.4a12.9,12.9,0,0,1,3.541.475v-.9c0-1.759-.974-2.543-3.469-2.543a11.907,11.907,0,0,0-4.681.856l-.309-2.614a14.85,14.85,0,0,1,5.608-1c4.633,0,6.178,1.948,6.178,5.8v8.745h-2.567Zm-.451-4.539a8.97,8.97,0,0,0-2.946-.428c-2.3,0-3.3.736-3.3,2.091,0,1.592,1.188,2.139,2.827,2.139,1.783,0,3.422-1,3.422-2Z",
    transform: "translate(-54.575 -9.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M167.555,33.838l-.38-1.45-.072-.023a6.024,6.024,0,0,1-4.752,1.782c-4.443,0-6.392-2.59-6.392-7.462,0-4.491,2.044-7.39,6.416-7.39a6.584,6.584,0,0,1,4.443,1.592l.048-.048-.048-1.9V15.375l3.375-.214V33.838Zm-.737-10.146a4.34,4.34,0,0,0-3.493-1.45c-2.8,0-3.873,1.378-3.873,4.586,0,3.279.9,4.681,3.873,4.681a4,4,0,0,0,3.493-1.521Z",
    transform: "translate(-65.235 -6.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M199.057,22.759l-6.439,14.257H188.84l-6.416-14.257h3.731L190,32.406l.689,1.782h.071l.665-1.782,3.9-9.647Z",
    transform: "translate(-76.305 -9.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M218.842,37.185c-5.18,0-7.461-2.447-7.461-7.437,0-4.966,2.3-7.437,7.461-7.437,5.2,0,7.39,2.471,7.39,7.437,0,4.99-2.186,7.437-7.39,7.437m0-2.732c2.828,0,3.9-1.283,3.9-4.7,0-3.446-1.069-4.7-3.9-4.7-2.851,0-3.945,1.259-3.945,4.7s1.094,4.7,3.945,4.7",
    transform: "translate(-88.417 -9.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M250.556,25.891a9.643,9.643,0,0,0-3.232-.594c-3.35,0-4.491,1.378-4.491,4.4,0,3.256,1.616,4.61,4.443,4.61a7.773,7.773,0,0,0,3.4-.76l.237,2.59a8.416,8.416,0,0,1-4.372,1.022c-4.729,0-7.224-2.543-7.224-7.437,0-4.586,2.186-7.366,7.319-7.366a12.186,12.186,0,0,1,4.11.713Z",
    transform: "translate(-100.102 -9.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M271.42,35.219l-.071-.024a6.322,6.322,0,0,1-4.753,1.877c-3.088,0-5.061-1.5-5.061-4.681,0-2.567,2-4.4,5.893-4.4a12.9,12.9,0,0,1,3.541.475v-.9c0-1.759-.974-2.543-3.469-2.543a11.907,11.907,0,0,0-4.681.856l-.309-2.614a14.85,14.85,0,0,1,5.608-1c4.633,0,6.178,1.948,6.178,5.8v8.745h-2.567Zm-.451-4.539a8.97,8.97,0,0,0-2.946-.428c-2.3,0-3.3.736-3.3,2.091,0,1.592,1.188,2.139,2.827,2.139,1.783,0,3.422-1,3.422-2Z",
    transform: "translate(-109.395 -9.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M298.259,25.891a9.643,9.643,0,0,0-3.232-.594c-3.35,0-4.491,1.378-4.491,4.4,0,3.256,1.616,4.61,4.443,4.61a7.773,7.773,0,0,0,3.4-.76l.237,2.59a8.415,8.415,0,0,1-4.372,1.022c-4.729,0-7.224-2.543-7.224-7.437,0-4.586,2.186-7.366,7.319-7.366a12.186,12.186,0,0,1,4.11.713Z",
    transform: "translate(-120.055 -9.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M315.563,36.968l.072-.19-7.3-14.02h3.873l4.349,9.41.76,1.759h.072l.594-1.806,3.35-9.362h3.636l-5.964,14.234c-1.236,2.946-2.97,4.158-5.537,4.158a6.771,6.771,0,0,1-2.685-.522l.285-2.4a4.1,4.1,0,0,0,1.782.379,2.707,2.707,0,0,0,2.708-1.639",
    transform: "translate(-128.973 -9.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M5.275,36.848A10.374,10.374,0,0,1,0,35.636l.428-2.709a9.982,9.982,0,0,0,4.9,1.283c2,0,2.827-.808,2.827-1.735,0-2.59-8.15-1.021-8.15-6.107,0-2.59,1.972-4.324,5.988-4.324a12.807,12.807,0,0,1,4.681.879l-.308,2.685a13.218,13.218,0,0,0-4.515-.832c-1.639,0-2.614.57-2.614,1.45,0,2.4,8.055.879,8.055,5.893,0,2.685-1.734,4.729-6.011,4.729",
    transform: "translate(0 -9.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M29.515,36.848a5.818,5.818,0,0,1-4.3-1.521l-.072.024.048,1.925v3.041H21.769V22.4l2.4-.143.737,1.449a7.12,7.12,0,0,1,4.728-1.663c4.135,0,6.345,2.115,6.345,7.366,0,5.085-2.567,7.437-6.463,7.437M28.731,24.99a4.489,4.489,0,0,0-3.54,1.45v6.155a4.172,4.172,0,0,0,3.422,1.5c2.281,0,3.9-.927,3.9-4.633,0-3.375-1.259-4.468-3.778-4.468",
    transform: "translate(-9.106 -9.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M57.956,34.953l-.071-.024a6.322,6.322,0,0,1-4.753,1.877c-3.089,0-5.061-1.5-5.061-4.681,0-2.567,2-4.4,5.893-4.4a12.9,12.9,0,0,1,3.54.475v-.9c0-1.759-.974-2.543-3.469-2.543a11.909,11.909,0,0,0-4.681.856L49.045,23a14.853,14.853,0,0,1,5.608-1c4.633,0,6.178,1.948,6.178,5.8v8.745H58.264ZM57.5,30.415a8.966,8.966,0,0,0-2.946-.428c-2.3,0-3.3.736-3.3,2.091,0,1.592,1.188,2.139,2.828,2.139,1.782,0,3.422-1,3.422-2Z",
    transform: "translate(-20.107 -9.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M73.434,36.58V22.442l2.685-.166.332,2.828h.072a5.245,5.245,0,0,1,4.8-3.018,5.817,5.817,0,0,1,1.71.237l-.213,3.208a5.931,5.931,0,0,0-1.759-.261,4.164,4.164,0,0,0-4.254,4.467V36.58Z",
    transform: "translate(-30.716 -9.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M96.126,24.59H98.6l4.135-5.275h3.921L101.425,25.8l5.418,7.77H102.9l-4.3-6.3H96.126v6.3H92.752V15.086l3.374-.19Z",
    transform: "translate(-38.796 -6.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M120.378,0l.315,3.561,3.4-.882.756,2.174-3.4,1.355L123.5,9.233l-1.607,1.323L119.37,7.72l-2.584,2.868-1.7-1.261,2.08-3.12-3.372-1.355.756-2.174,3.435.882L118.33,0Z",
    transform: "translate(-47.597)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2016b78cc6927c438f4836d2fd50955e.svg";
export { ForwardRef as ReactComponent };